<template>
    <div class="position-relative">
        <select :id="id" v-model="selected" class="custom-select custom-select-sm" :disabled="loaded === null">
            <option v-for="result in results" :value="result.value">{{result.key}} ({{result.male}}/{{result.female}})</option>
        </select> <em class="fa fa-sync fa-spin position-absolute loader" v-show="loaded===null"></em>
    </div>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                results: [],

                selected: null,
                waitingSelect: null,

                loaded: null,

                errors: [],

                q: '',
            }
        },
        props: {
            value: [String, null],
            id: [String]
        },
        watch: {
            results() {
                this.$store.commit('titleStore/titles', this.results);
            },
            selected(n, o) {
                if(n !== undefined) {
                    this.$emit('input', n);
                }
            },
            value(n, o) {
                if(this.loaded !== null) {
                    this.select(n);
                } else {
                    this.waitingSelect = n;
                }
            }
        },
        mounted() {
            this.waitingSelect = this.value;
            if(this.$store.getters['titleStore/titles'] !== null) {
                this.results = this.$store.getters['titleStore/titles'];
                this.loaded = new Date();
            } else {
                this.refresh();
            }
        },
        computed: {
        },
        methods: {
            refresh() {
                this.showing = null;
                this.loaded = null;
                this.errors = [];

                axios.get('/api/v1/leads/afas/titles')
                    .then(response => {
                        this.loaded = new Date();
                        this.results = response.data;

                        if(this.waitingSelect !== null) {
                            this.select(this.waitingSelect);
                            this.waitingSelect = null;
                        }
                    })
                    .catch(error => {
                        this.loaded = new Date();
                        if (typeof error.response.data === 'object') {
                            if(error.response.data.errors) {
                                this.errors = _.flatten(_.toArray(error.response.data.errors));
                            } else {
                                this.errors = [error.toString()];
                            }
                        } else {
                            this.errors = ['Something went wrong. Please try again.'];
                        }
                    });
            },
            select(value) {
                for(let i in this.results) {
                    if(this.results.hasOwnProperty(i)) {
                        let r = this.results[i];
                        if(r.value === value) {
                            this.selected = r.value;
                        }
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    .loader {
        margin-top: -22px;
        margin-left: 12px;
    }
</style>